var render = function render(){var _vm=this,_c=_vm._self._c;return _c('home-layout',{class:[_vm.contentClass]})
}
var staticRenderFns = []

export { render, staticRenderFns }